import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "category__category-card position-relative" };
const _hoisted_2 = { style: { "flex": "1 1 auto" } };
const _hoisted_3 = { class: "image__container" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = { class: "footer_caption" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (_openBlock(), _createBlock(_component_g_link, {
        src: 'to://' + _ctx.category.address,
        title: _ctx.category.caption
    }, {
        default: _withCtx(() => [
            _createElementVNode("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_ctx.category?.iconUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.category?.iconUrl,
                                alt: _ctx.category.caption,
                                class: "image-item"
                            }, null, 8, _hoisted_4))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.category.caption), 1)
            ])
        ]),
        _: 1
    }, 8, ["src", "title"]));
}
